import { Component, OnInit, Input, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { ChartComponent } from '@progress/kendo-angular-charts';
import { DataStateChangeEvent, GroupRowArgs } from '@progress/kendo-angular-grid';
import { AggregateDescriptor, GroupDescriptor, State, process } from '@progress/kendo-data-query';
import * as saveAs from 'file-saver';
import { ReportBuilderExecutorComponent } from '../report-builder-executor.component';

@Component({
  selector: 'app-report-builder-executor-element',
  templateUrl: './report-builder-executor-element.component.html',
  styleUrls: ['./report-builder-executor-element.component.css'] 
})
export class ReportBuilderExecutorElementComponent implements OnInit {

  constructor() { }
  private _element: any;
  @Input() set element(val) {
    this._element = val;
    debugger;
    this.gridData= process(this.element?.rawData, this.state);
  }
  public get element() { return this._element; }
  @Input() parent: ReportBuilderExecutorComponent;
  @ViewChild('chart', { read: ChartComponent }) chart: ChartComponent;
  ngOnInit() {
  }
  public exportChart() {
    this.chart.exportImage().then((dataURI) => {
      saveAs(dataURI, this.element.name + ".png");
    });
  }

  public crossingValues: number[] = [0, 13];

    public aggregates: AggregateDescriptor[] = [
      { field: "sales", aggregate: "sum" },
      { field: "mass", aggregate: "sum" },
  ];

  public group: GroupDescriptor[] = [
    { field: 'customer Name', aggregates: this.aggregates }
  ];
  public initiallyExpanded = false;
  public expandedKeys: string[] = [];
  public groupChange(groups: GroupDescriptor[]): void {
    this.expandedKeys = [];
  }

  public groupKey = (groupRow: GroupRowArgs): string => {
    if (!groupRow) {
      return null;
    }

    // Checks if there's a parent key and prepends it.
    return [this.groupKey(groupRow.parentGroup), groupRow.group.value]
      .filter((id) => id !== null)
      .join("#");
  };

  public dataStateChange(state: DataStateChangeEvent): void {
    debugger;
    if (state && state.group) {
      state.group.map(group => group.aggregates = this.aggregates);
    }

    this.state = state;

    this.gridData = process(this.element?.rawData, this.state);
  }

  public gridData: any //= process(this.element?.rawData, this.state);
  public state: State = {
    group: [{ field: 'customer Name', aggregates: this.aggregates },
      { field: 'year', aggregates: this.aggregates },
      { field: 'month', aggregates: this.aggregates }]
  };

  public expandAll(): void {
    this.expandedKeys = [];
    this.initiallyExpanded = true;
  }

  public collapseAll(): void {
    this.expandedKeys = [];
    this.initiallyExpanded = false;
  }
}
